import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { login, clearError } from '../store/authSlice';
import Alert from '../components/Alert';
import '../styles/Auth.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(clearError());
    setLoginError('');
  }, [dispatch]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoginError('');
    
    if (!email.trim() || !password.trim()) {
      setLoginError('Please enter both email and password');
      return;
    }

    if (!email.includes('@')) {
      setLoginError('Please enter a valid email address');
      return;
    }
    
    console.log('🔐 Login form submitted:', { email });
    setIsSubmitting(true);
    
    try {
      const result = await dispatch(login({ email, password }));
      console.log('🔐 Login result:', result);
      
      if (result.type === 'auth/login/fulfilled') {
        console.log('✅ Login successful, navigating to dashboard');
        navigate('/dashboard');
      } else {
        console.error('❌ Login failed:', result);
        const errorMsg = result.payload || result.error?.message || 'Invalid email or password. Please try again.';
        console.log('Setting error message:', errorMsg);
        setLoginError(String(errorMsg));
        setIsSubmitting(false);
      }
    } catch (err) {
      console.error('❌ Login exception:', err);
      const errorMsg = err.message || 'Network error: Unable to connect to server. Please check your connection and try again.';
      console.log('Setting exception error:', errorMsg);
      setLoginError(errorMsg);
      setIsSubmitting(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>🏭 IndustrialIQ</h1>
          <p>AI-Powered Document Intelligence</p>
        </div>
        
        {(loginError || error) && (
          <Alert 
            type="error" 
            message={loginError || error}
            onClose={() => {
              setLoginError('');
              dispatch(clearError());
            }}
          />
        )}
        
        <form onSubmit={handleSubmit} className="auth-form">
          <h2>Welcome Back</h2>
          
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
              disabled={loading || isSubmitting}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
              disabled={loading || isSubmitting}
            />
          </div>
          
          <button type="submit" className="btn-primary" disabled={loading || isSubmitting}>
            {loading || isSubmitting ? '⏳ Logging in...' : 'Log In'}
          </button>
          
          <div className="auth-links">
            <p className="auth-link">
              Don't have an account? <Link to="/register">Sign up</Link>
            </p>
            <p className="auth-link" style={{ fontSize: '13px', marginTop: '10px' }}>
              <Link to="/forgot-password" style={{ color: '#0B3D91' }}>Forgot your password?</Link>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
